import { ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { useRecoilValue } from 'recoil';
import { ThemeProvider as ThemeProviderStyled } from 'styled-components';

import GlobalStyle from 'styles/GlobalStyle';
import { selectedThemeState, THEME_TYPE } from 'styles/styledComponents';

type Props = {
  children: ReactNode;
};

const currentTheme = {};

const ThemeProvider = ({ children }: Props) => {
  const themeName = useRecoilValue<THEME_TYPE>(selectedThemeState);

  return (
    <ThemeProviderStyled theme={currentTheme}>
      <Helmet>
        {themeName === THEME_TYPE.DARK && (
          <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/styles/${THEME_TYPE.DARK}.css`} />
        )}
      </Helmet>

      <GlobalStyle />
      {children}
    </ThemeProviderStyled>
  );
};

export default ThemeProvider;
